import { render, staticRenderFns } from "./classic.vue?vue&type=template&id=31fae3c9&"
import script from "./classic.vue?vue&type=script&lang=js&"
export * from "./classic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports